import { AllDeeplinksPlugin } from "../domain/plugin/AllDeeplinksPlugin";

export class AllDeeplinksPluginImpl implements AllDeeplinksPlugin {
  private readonly storageKey = "deeplinks";

  getDeeplinks(): string[] {
    const stored = localStorage.getItem(this.storageKey);
    return stored ? JSON.parse(stored) : [];
  }

  setDeeplinks(links: string[]): void {
    localStorage.setItem(this.storageKey, JSON.stringify(links));
  }
}
